import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

export const StateModal = ({
  isOpen,
  onClose,
  title,
  content,
  sx,
  actionsSx,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose(true)}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '16px',
          boxShadow: '0px 2px 4px 0px #00000040',
          textAlign: 'center',
          ...sx,
        },
      }}
    >
      <IconButton
        aria-label='close'
        onClick={() => onClose(true)}
        sx={{
          position: 'absolute',
          right: 30,
          top: 30,
          height: 24,
          width: 24,
          color: (theme) => theme.palette.grey[400],
        }}
      >
        <CancelOutlinedIcon />
      </IconButton>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={actionsSx}>
        <Button
          sx={{ px: '15px' }}
          onClick={() => onClose(true)}
          variant='contained'
          color='primary'
        >
          Continue Editing
        </Button>
        <Button
          onClick={() => onClose(false)}
          variant='text'
          color='primary'
        >
          <Typography
            component={'span'}
            variant='subtitle2'
            color='textSecondary'
            className='underline underline-offset-2'
          >
            or exit to website dashboard
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
